import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { supabase } from "../supabase";
import AdminGuard from "../components/admin/AdminGuard";
import AdminLayout from "../components/admin/AdminLayout";
import AdminArchitects from "../components/admin/AdminArchitects";
import AdminProjects from "../components/admin/AdminProjects";
import AdminUsers from "../components/admin/AdminUsers";
import AdminCommunication from "../components/admin/AdminCommunication";

// --- Metrics for the index route ---

const METRICS = [
  { key: "architects", label: "Architectes",    icon: "▲", color: "#7EB8C9" },
  { key: "projects",   label: "Projets actifs", icon: "⬡", color: "#C9A96E" },
  { key: "users",      label: "Utilisateurs",   icon: "◈", color: "#A8C97E" },
  { key: "clients",    label: "Clients",        icon: "◆", color: "#FC8181" },
];

function MetricCard({ metric, value, loading }) {
  return (
    <div style={{ background: "#1A1916", border: "1px solid #2A2924", borderRadius: 12, padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ fontSize: 10, color: "#7A7468", textTransform: "uppercase", letterSpacing: ".08em", fontWeight: 600 }}>
          {metric.label}
        </span>
        <div style={{ width: 30, height: 30, borderRadius: 8, background: metric.color + "18", border: `1px solid ${metric.color}40`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: metric.color }}>
          {metric.icon}
        </div>
      </div>
      <div style={{ fontSize: 34, fontWeight: 600, color: "#E8E2D8", lineHeight: 1 }}>
        {loading ? <div className="spinner" /> : value}
      </div>
    </div>
  );
}

function AdminHome() {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchMetrics() {
      const [architects, projects, users, clients] = await Promise.all([
        supabase.from("profiles").select("*", { count: "exact", head: true }).eq("role", "architect"),
        supabase.from("projects").select("*", { count: "exact", head: true }),
        supabase.from("profiles").select("*", { count: "exact", head: true }),
        supabase.from("profiles").select("*", { count: "exact", head: true }).eq("role", "client"),
      ]);
      setCounts({
        architects: architects.count ?? 0,
        projects:   projects.count   ?? 0,
        users:      users.count      ?? 0,
        clients:    clients.count    ?? 0,
      });
      setLoading(false);
    }
    fetchMetrics();
  }, []);

  return (
    <div>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, fontWeight: 400 }}>Tableau de bord</h1>
        <p style={{ fontSize: 13, color: "#7A7468", marginTop: 4 }}>Vue d'ensemble de la plateforme</p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 16 }}>
        {METRICS.map(m => (
          <MetricCard key={m.key} metric={m} value={counts[m.key] ?? 0} loading={loading} />
        ))}
      </div>
    </div>
  );
}

// --- Admin shell ---

export default function AdminDashboard() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (!session) return;
      const { data } = await supabase.from("profiles").select("name").eq("id", session.user.id).single();
      setUserName(data?.name || session.user.email || "Admin");
    });
  }, []);

  return (
    <AdminGuard>
      <AdminLayout userName={userName}>
        <Routes>
          <Route index element={<AdminHome />} />
          <Route path="architects" element={<AdminArchitects />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="communication" element={<AdminCommunication />} />
        </Routes>
      </AdminLayout>
    </AdminGuard>
  );
}
